import React from 'react';
import Requisites from './Requisites';

const PaymentRequisites: React.FC = () => <Requisites />;

export default PaymentRequisites;
